import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { AgentProfileCreator } from '@atlaskit/rovo-agent-components';
import { useTeamsUser } from '@atlassian/teams/user';

import { trimUserARI } from '../../hooks/utils';
import useCloudUser from '../WithCloudUser';

export const AgentCreator = ({
	creator,
	create_type,
}: {
	creator?: string;
	create_type: string;
}) => {
	const userId = create_type === 'CUSTOMER' && creator ? trimUserARI(creator) : '';
	const { data: userData, isLoading: userInfoIsLoading } = useCloudUser({
		userId: userId || '',
		skip: fg('migrate_cloud_user_to_agg_user_query'),
	});
	const { isLoading: loadingAgg, data: dataAgg } = useTeamsUser(
		userId,
		!userId || !fg('migrate_cloud_user_to_agg_user_query'),
	);

	const getCreator = () => {
		switch (create_type) {
			case 'SYSTEM':
				return { type: 'SYSTEM' as const };
			case 'THIRD_PARTY':
				return { type: 'THIRD_PARTY' as const, name: creator ?? '' };
			case 'FORGE':
				return { type: 'THIRD_PARTY' as const, name: creator ?? '' };
			case 'CUSTOMER':
				return {
					type: 'CUSTOMER' as const,
					name: fg('migrate_cloud_user_to_agg_user_query')
						? dataAgg?.fullName || ''
						: userData.fullName,
					profileLink: `/people/${fg('migrate_cloud_user_to_agg_user_query') ? dataAgg?.id : userData.id}`,
				};
		}
	};
	return (
		<AgentProfileCreator
			creator={getCreator()}
			isLoading={fg('migrate_cloud_user_to_agg_user_query') ? loadingAgg : userInfoIsLoading}
			onCreatorLinkClick={() => {}}
		/>
	);
};
